/* Age gate — 30-day TTL */
(function () {
  const KEY = 'ivg-pk-age-verified';
  const TTL_DAYS = 30;

  document.addEventListener('DOMContentLoaded', function () {
    const gate = document.getElementById('AgeGate');
    if (!gate) return;

    let verified = false;
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) {
        const data = JSON.parse(raw);
        const ageMs = Date.now() - (data.t || 0);
        const ttlMs = TTL_DAYS * 86400 * 1000;
        if (data.v && ageMs < ttlMs) verified = true;
      }
    } catch (e) {}

    if (!verified) {
      gate.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    gate.querySelector('[data-age-yes]')?.addEventListener('click', () => {
      try { localStorage.setItem(KEY, JSON.stringify({ v: true, t: Date.now() })); } catch (e) {}
      gate.classList.remove('is-open');
      document.body.style.overflow = '';
    });

    gate.querySelector('[data-age-no]')?.addEventListener('click', () => {
      // Don't redirect off-site — fat-finger taps shouldn't permanently lose visitors.
      // Block them in-place with a soft message; they can refresh if it was an accident.
      const card = gate.querySelector('.age-gate-card');
      if (card) {
        card.innerHTML = '<span class="icon">🔞</span>' +
          '<h2>You must be 18 or over to enter.</h2>' +
          '<p style="margin-top:8px;">We sell products that contain nicotine. They are not for sale to anyone under 18.</p>' +
          '<p style="margin-top:16px;font-size:13px;opacity:.7;">If this was a mistake, refresh the page.</p>';
      }
    });
  });
})();
